const StatItem = ({ label, value, color }) => (
    <div className="flex-1 text-center">
        <div className="text-xs text-white/80 font-medium mb-1">{label}</div>
        <div className={`text-lg font-bold text-white ${color ? 'drop-shadow-sm' : ''}`}>{value}</div>
    </div>
);

export default StatItem;